(function () {
    'use strict';

    angular
        .module('app')
        .factory('enumFactory', enumFactory);

    enumFactory.$inject = ['$http'];

    //factory used for common enums throughout the application

    function enumFactory($http) {
        var service = {
            //searchOperator coincides with AdeptSearchTerm.SearchOperator
            searchOperator: {
                Starts: 0,
                Equals: 1,
                Contains: 2,
                NotStarts: 3,
                NotEquals: 4,
                NotContains: 5,
                LessThan: 6,
                GreaterThan: 7,
                LessThanEqual: 8,
                GreaterThanEqual: 9,
                Empty: 10,
                NotEmpty: 11,
                DateRange: 12,
                AfterDate: 13,
                BeforeDate: 14,
                OnDate: 15,
                Wildcard: 16
            }
        };
        return service;
    }
})();